import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: white;
  margin-left: 2rem;
  margin-right: 2rem;
  margin-top: 0.6rem;
  user-select: none;
  max-height: 7.375rem;

  cursor: pointer;
  :hover {
    background: rgba(207, 248, 231, 0.6);
  }
`;

export const IterableTitleSlot = styled.div`
  display: flex;
  margin-top: 1rem;
  margin-left: 1.4rem;
  align-items: center;
`;

export const IterableTitle = styled.span`
  font-family: "Sora";
  font-style: normal;
  font-weight: 700;
  font-size: 1.22rem;
  line-height: 1.5rem;
`;

export const CurrentStatus = styled.div`
  padding-right: 0.67rem;
  padding-left: 0.67rem;
  margin-left: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;

  background: #126710;
  /*
    ${({ status }) =>
    status === "Em Dia"
      ? "#A0F79E"
      : status === "Em risco"
      ? "#F8E47C"
      : "#FFBAAB"};
    */
  border-radius: 0.2rem;

  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1rem;

  color: #cff9d3;
  /* ${({ status }) =>
    status === "Em Dia"
      ? "#1C7A1A"
      : status === "Em risco"
      ? "#807228"
      : "#D93333"};
      */
`;
export const Warning = styled.span`
  margin-left: 0.6rem;
  font-family: "Sora";
  font-style: normal;
  font-weight: 400;
  font-size: 0.8rem;
  line-height: 1rem;
  color: ${({ status }) => (status === "Delayed" ? "#eb5757" : "#1C7A1A")};
`;

export const IterableSubTitle = styled.span`
  font-weight: 400;
  font-size: 0.8rem;
  line-height: 1rem;
  margin-top: 0.4rem;
  margin-left: 1.4rem;
  color: #717171;
`;
export const GreyBar = styled.div`
  height: 1rem;
  align-self: center;
  width: 98%;
  border-bottom: 0.07rem solid #ccc;
`;
export const IterableBottom = styled.div`
  display: flex;
  height: 4rem;
  width: 100%;
`;

export const BottomTitles = styled.span`
  font-family: "Sora";
  font-style: normal;
  font-weight: 400;
  font-size: 0.76rem;
  line-height: 0.95rem;
  color: #7e858f;

  margin-top: 0.8rem;
`;

export const BottomText = styled.div`
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1rem;
  padding: 0.2rem 0.6rem;
  color: ${({ status }) =>
    status === "Delayed"
      ? "#eb5757"
      : status === "Concluido"
      ? "#1C7A1A"
      : "#232323"};

  margin-top: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: space-around;

  svg {
    fill: #40e5a0;
    width: 1.07rem;
    height: 1.07rem;
    margin-right: 0.4rem;
  }
  path {
    stroke: #40e5a0;
  }

  span {
    font-family: "Sora";
    font-style: normal;
    font-weight: 800;
    font-size: 0.8rem;
    line-height: 1rem;
    text-align: center;
    color: #1ba3f0;
    position: relative;
    margin-left: 0.4rem;
  }
`;
export const IterableData = styled.div`
  height: 100%;
  width: ${({ width }) => width};
  display: flex;
  flex-direction: column;
  align-items: center;
  border-right: 0.07rem solid #ccc;
`;

export const LastData = styled.div`
  width: ${({ width }) => width};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 0.7rem 0rem 0.7rem 0rem;
`;

export const PlaceHolder = styled.div`
  width: 2rem;
  height: 2rem;
  border-radius: 100%;
  margin-right: -0.67rem;
  background-color: ${({ color }) => color};
`;
export const PlaceHolderCounter = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 2rem;
  height: 2rem;
  color: #fff;
  background-color: #42464c;
  border-radius: 100%;
  margin-right: 1.5rem;
  margin-left: 0.8rem;
`;

export const PBContainer = styled.div`
  position: relative;
  width: 84%;
  margin-top: 0.1rem;
`;

export const PBNumber = styled.span`
  width: 20%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 40%;
  top: 2px;

  font-family: "Sora";
  font-style: normal;
  font-weight: 400;
  font-size: 0.76rem;
  line-height: 0.95rem;

  color: #000;
`;

export const ImageHolder = styled.img`
  width: 2rem;
  height: 2rem;
  border-radius: 100%;
  margin-right: -0.67rem;
`;

export const ImageDiv = styled.div`
  height: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
`;
